import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ADMIN_API_URL } from "../../constants";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const CustomerKYC = () => {
    const { customerId } = useParams();
    const [kycDocuments, setKycDocuments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchKYC = async () => {
            try {
                const response = await fetch(`${ADMIN_API_URL}kyc/${customerId}`);
                const result = await response.json();
                if (result.data) {
                    setKycDocuments(result.data);
                } else {
                    setKycDocuments([]);
                }
            } catch (err) {
                setError("Failed to load KYC documents");
            } finally {
                setLoading(false);
            }
        };

        fetchKYC();
    }, [customerId]);

    if (loading) return <p>Loading KYC data...</p>;
    if (error) return <p>{error}</p>;

    return (
        <>
            <Header />
            <div id="wrapper">
                <div class="normalheader ">
                    <div class="hpanel">
                        <div class="panel-body">
                            <a class="small-header-action" href="">
                                <div class="clip-header">
                                    <i class="fa fa-arrow-up"></i>
                                </div>
                            </a>
                            <h2 class="font-light m-b-xs">
                            KYC Documents for Customer: {customerId}
                            </h2>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="hpanel">
                                <div class="panel-body">
                                    <div class="table-responsive">
                                        <table cellPadding="1" cellSpacing="1" className="table">
                                            <thead>
                                                <tr>
                                                    <th>Document Type</th>
                                                    <th>Document Value</th>
                                                    <th>Status</th>
                                                    <th>Uploaded At</th>
                                                    <th>Document</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {kycDocuments.length > 0 ? (
                                                    kycDocuments.map((doc) => (
                                                        <tr key={doc.id}>
                                                            <td>{doc.documentType}</td>
                                                            <td>{doc.documentValue}</td>
                                                            <td>{doc.status}</td>
                                                            <td>{new Date(doc.uploadedAt).toLocaleDateString()}</td>
                                                            <td>
                                                                <a href={doc.documentPath} target="_blank" rel="noopener noreferrer">
                                                                    View Document
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5">No KYC documents found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default CustomerKYC;
